import { useThree } from "@react-three/fiber";
import { useEffect } from "react";

export default function CanvasIdSetter({ id }: { id: string }) {
  const gl = useThree((state) => state.gl);

  useEffect(() => {
    gl.domElement.id = id;
  }, [gl]);

  return null;
}
